module.exports = __webpack_public_path__ + "img/Wekiwi_80X30.e13f4248.png";